import React, { ReactNode } from 'react';

interface Props {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
  overlay?: ReactNode;
  className?: string;
}

const ChatPanel: React.FC<Props> = ({ header, body, footer, overlay, className }) => (
  <div className={`bot-panel${className ? ` ${className}` : ''}`}>
    {header}
    <div className="bot-panel__body">{body}</div>
    {footer}
    {overlay}
  </div>
);

export default ChatPanel;
